<script setup lang="ts">

import { RowSlot } from '@shared/ui/other'
import { NativeSelect } from '@shared/ui/fields'

import { useKidFields } from '../model/kid-fields.hook'

defineOptions({
  name: 'KidSelectGrade',
})

const {
  refGrade,
  gradeOptions,
  setGrade,
} = useKidFields()
</script>

<template>
  <RowSlot label="Grade">
    <NativeSelect
      id="grade"
      name="grade"
      placeholder="Select here"
      placeholder-enabled
      :value="refGrade"
      :options="gradeOptions"
      @change="setGrade"
    />
  </RowSlot>
</template>
